/**
 * Product Groups Endpoints
 */

export const apiPostProductGroup = async (
  productGroup: ProductGroupCreateUpdate,
): Promise<AxiosResponse<ProductGroup>> => {
  return await userManagementAxiosInstance.post('product_groups', productGroup);
};

export const apiGetProductGroups = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
): Promise<AxiosResponse<PaginatedProductGroup>> => {
  return await userManagementAxiosInstance.get(`product_groups?limit=${limit}&offset=${offset}`);
};

export const apiGetProductGroup = async (
  id: string | number,
): Promise<AxiosResponse<ProductGroup>> => {
  return await userManagementAxiosInstance.get(`product_groups/id/${id}`);
};

export const apiPutProductGroup = async (
  productGroup: ProductGroupCreateUpdate,
): Promise<AxiosResponse<ProductGroup>> => {
  return await userManagementAxiosInstance.put(
    `product_groups/id/${productGroup.id}`,
    productGroup,
  );
};

export const apiDeleteProductGroup = async (
  id: string | number,
): Promise<AxiosResponse<ProductGroup>> => {
  return await userManagementAxiosInstance.delete(`product_groups/id/${id}`);
};
